import React from "react";
import { CheckCircle2 } from "lucide-react";
import { SectionFrame } from "./SectionFrame";
import { StatusBadge } from "../../StatusBadge";

/** Monthly Record - Approved Attendance section (spec P0-D). Derives entirely from the
 * authoritative timekeeping month-review data already fetched for TimecardSection above -
 * approved-hours totals are never recalculated independently on the frontend. */
export const ApprovedAttendanceSection = ({ data, loading, error, onRetry }) => {
  const records = data?.daily_records || [];
  const hasWorkedMinutes = records.some((r) => typeof r.worked_duration_minutes === "number");
  const approvedHours = hasWorkedMinutes
    ? (records.reduce((sum, r) => sum + (r.worked_duration_minutes || 0), 0) / 60).toFixed(1)
    : null;
  const isLocked = data?.official_record_status === "LOCKED_FOR_PAYROLL";

  return (
    <SectionFrame
      title="Approved Attendance" icon={CheckCircle2} testId="monthly-approved-attendance-section"
      loading={loading} error={error} onRetry={onRetry}
      isEmpty={!data?.pair && records.length === 0}
      emptyMessage="Attendance has not yet been approved for this period."
    >
      <dl className="text-sm space-y-2">
        <div className="flex justify-between"><dt className="text-slate-500">Approved hours</dt>
          <dd data-testid="monthly-approved-hours">{approvedHours !== null ? `${approvedHours} h` : "Not yet calculated"}</dd></div>
        <div className="flex justify-between"><dt className="text-slate-500">Approval status</dt>
          <dd><StatusBadge status={data?.official_record_status || "SOURCE_PENDING"} /></dd></div>
        <div className="flex justify-between"><dt className="text-slate-500">Locked for payroll</dt>
          <dd data-testid="monthly-locked-status">{isLocked ? "Yes" : "No"}</dd></div>
        <div className="flex justify-between"><dt className="text-slate-500">Approved by</dt>
          <dd data-testid="monthly-approved-by">{data?.approved_by || "-"}</dd></div>
        <div className="flex justify-between"><dt className="text-slate-500">Approved at</dt>
          <dd data-testid="monthly-approved-at">{data?.approved_at ? new Date(data.approved_at).toLocaleString() : "-"}</dd></div>
        <div className="flex justify-between"><dt className="text-slate-500">Payroll-consumed status</dt>
          <dd data-testid="monthly-payroll-consumed-status">{data?.payroll_line_status || "Not yet calculated"}</dd></div>
      </dl>
    </SectionFrame>
  );
};
